(function () {
  const acc = document.getElementsByClassName('store-switcher-accordion');

  const body = document.body;
  // Each of these is queried as a collection rather than a single node: the switcher is
  // rendered from snippets/store-switcher.liquid in both a desktop and a mobile branch,
  // and jQuery bound every match.
  const toggles = document.querySelectorAll('.store-switcher');
  const popups = document.querySelectorAll('.store-switcher-popup');
  const popupOverlays = document.querySelectorAll('.store-switcher-popup-overlay');
  const popupExitButtons = document.querySelectorAll('.store-switcher-exit-button');

  // Country selection is handled by Shopify's localization form inside the popup
  // (snippets/store-switcher-markets-popup.liquid); this file only manages the
  // popup open/close state and the region accordions.

  function openPopup(e) {
    e.preventDefault();
    popups.forEach(function (popup) {
      popup.classList.add('open');
    });
    popupOverlays.forEach(function (overlay) {
      overlay.classList.add('open');
    });
    body.classList.add('stop-scroll');
  }

  function closePopup() {
    popups.forEach(function (popup) {
      popup.classList.remove('open');
    });
    body.classList.remove('stop-scroll');
    popupOverlays.forEach(function (overlay) {
      overlay.classList.remove('open');
    });
    setTimeout(function () {
      for (let i = 0; i < acc.length; i++) {
        acc[i].classList.remove('active');
        const panel = acc[i].nextElementSibling;
        if (panel) {
          panel.style.maxHeight = null;
        }
      }
    }, 200);
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', openPopup);
  });

  popupOverlays.forEach(function (overlay) {
    overlay.addEventListener('click', closePopup);
  });

  popupExitButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function () {
      this.classList.toggle('active');
      const panel = this.nextElementSibling;
      if (!panel) {
        return;
      }
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  }
})();
